import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PLANE_TICKETS_URL } from "../../settings/APISetting";
import { arrayFilter, dateFormatter, output } from "../../settings/themeSettings";
import api from "../../config/axiosConfig";



export const fetchBillets = createAsyncThunk('fetch-billets', async (params = {}) => {
    const { startDate, endDate } = params;

    // Construire les params pour axios
    const queryParams = {};
    if (startDate && endDate) {
        queryParams.startDate = startDate;
        queryParams.endDate = endDate;
    }

    const response = await api.get(PLANE_TICKETS_URL, { params: queryParams });
    return response.data;
});



const billetsSlice = createSlice({


    name: 'billets',
    initialState: { billets: [], fetchBilletsStatus: '' },
    reducers: {
        filterBillets: (state, action) => {
            output(action);
            state.billets = arrayFilter(new RegExp(action.payload.nail), state.billets);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchBillets.fulfilled, (state, action) => {

            let placeholder = action.payload;
            output({ placeholder });
            if ((Array.isArray(placeholder))) {
                placeholder = placeholder.map((b) => {

                    b.marge = (b.tarif - b.montantAchat);
                    b['marge %'] = ((b.tarif - b.montantAchat) / b.tarif) * 100;
                    b['marge %'] = Math.round(b['marge %']) + '%';

                    // Debug pour analyser les données de dateVol avant formatage
                    console.log('🔍 Debug dateVol avant formatage:', {
                        id: b.id,
                        numero: b.numero,
                        dateVolOriginal: b.dateVol,
                        dateVolType: typeof b.dateVol,
                        dateVolRetourOriginal: b.dateVolRetour,
                        dateVolRetourType: typeof b.dateVolRetour
                    });

                    // Format dates with safety check
                    b.dateVol = dateFormatter(b.dateVol) || b.dateVol || '--';
                    b.dateVolRetour = dateFormatter(b.dateVolRetour) || b.dateVolRetour || '--';

                    // Debug après formatage
                    console.log('✅ Debug dateVol après formatage:', {
                        id: b.id,
                        numero: b.numero,
                        dateVolFormatted: b.dateVol,
                        dateVolRetourFormatted: b.dateVolRetour
                    });

                    return b;
                });
                output({ placeholder });


                state.billets = placeholder;
            }





            state.fetchBilletsStatus = 'success';
        }).addCase(fetchBillets.pending, (state, action) => {
            state.fetchBilletsStatus = 'loading';

        }).addCase(fetchBillets.rejected, (state, action) => {
            output(action);

            state.fetchBilletsStatus = 'error';

        });
    }

});

export const { filterBillets } = billetsSlice.actions;
export default billetsSlice;